import { render, staticRenderFns } from "./AppMultiImagesUploader.vue?vue&type=template&id=0feb99df&scoped=true&"
import script from "./AppMultiImagesUploader.vue?vue&type=script&lang=ts&"
export * from "./AppMultiImagesUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AppMultiImagesUploader.vue?vue&type=style&index=0&id=0feb99df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb99df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
